<spark-layout>
  <layout-content>

    <div class="dashboard">
      <div class="dashboard__welcome">
        <h1>{{ name | greeter }}</h1>
        <h3>Nice to see you again.</h3>
      </div>

      <!-- dashboard / insights -->
      <div class="dashboard__insights">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg">
            <app-loan-insight></app-loan-insight>
          </div>
          <div class="col-12 col-sm-6 col-lg">
            <app-opportunity-insight></app-opportunity-insight>
          </div>
          <div class="col-12 col-sm-6 col-lg">
            <app-lead-insight></app-lead-insight>
          </div>
          <div class="col-12 col-sm-6 col-lg-12 col-xl-4">
            <app-task-list></app-task-list>
          </div>
        </div>
      </div>

      <!-- dashboard / sections -->
      <div class="dashboard__content">
        <div class="row">
          <div class="col-12 col-lg">
            <div class="row mb-lg">
              <div class="col">
                <spark-reports-lending-activity
                  *sparkFeatureFlag="reportsFlag; else mockChart">
                </spark-reports-lending-activity>
                <ng-template #mockChart>
                  <app-lending-activity></app-lending-activity>
                </ng-template>
              </div>
            </div>
            <div class="row mb-md">
              <div class="col">
                <app-opportunity-list></app-opportunity-list>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="row mb-lg">
              <div class="col">
                <app-announcement-list></app-announcement-list>
              </div>
            </div>
            <div class="row mb-lg">
              <div class="col">
                <agp-shared-aggregator-wrapper>
                  <ng-template agpSharedAggregator="mpm">
                    <spark-mpm-store-details></spark-mpm-store-details>
                  </ng-template>
                  <ng-template agpSharedAggregator="lns">
                    <spark-store-details></spark-store-details>
                  </ng-template>
                  <ng-template agpSharedAggregator="nmb">
                    <spark-nmb-store-details></spark-nmb-store-details>
                  </ng-template>
                </agp-shared-aggregator-wrapper>
              </div>
            </div>
            <div class="row mb-lg">
              <div class="col">
                <agp-shared-aggregator-wrapper>
                  <ng-template agpSharedAggregator="mpm">
                    <spark-mpm-contact-us></spark-mpm-contact-us>
                  </ng-template>
                  <ng-template agpSharedAggregator="lns">
                    <spark-contact-us></spark-contact-us>
                  </ng-template>
                  <ng-template agpSharedAggregator="nmb">
                    <spark-nmb-contact-us></spark-nmb-contact-us>
                  </ng-template>
                </agp-shared-aggregator-wrapper>
              </div>
            </div>
            <div class="row mb-lg">
              <div class="col">
                <agp-shared-aggregator-wrapper>
                  <ng-template agpSharedAggregator="nmb">
                    <spark-lending-partner-program></spark-lending-partner-program>
                  </ng-template>
                </agp-shared-aggregator-wrapper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </layout-content>
</spark-layout>
